// extracted by mini-css-extract-plugin
export default {"bg":"NoArticleBg_bg__fVpo9"};